export enum ESpaceAlign {
  Start = 'start',
  End = 'end',
  Center = 'center',
  Baseline = 'baseline',
}
